import React from 'react';
import '../less/brokerage-services.less'
import hero_img from '../img/hero_img.png';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import advantages_items from '../enums/advantages_items.json';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import tariffsData from '../enums/tariffs_data.json';
import DOMPurify from 'utils/sanitize';

export default function template() {
  const hero_data = {
    title: 'BROKERAGE_SERVICES_NEW_HERO_TITLE',
    text: 'BROKERAGE_SERVICES_NEW_HERO_TEXT',
  }

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3
  };

  const advantagesItems = advantages_items.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="brokerage-services">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className="content">
        <div className="info">
          <div className="container">
            <h2 className="info__title">{this.l10n('BROKERAGE_SERVICES_NEW_INFO_TOP_TITLE')}</h2>
            <div className="info__text">{this.l10n('BROKERAGE_SERVICES_NEW_INFO_TOP_TEXT')}</div>
          </div>
        </div>
        <Advantages
          items={advantagesItems}
          title={'BROKERAGE_SERVICES_NEW_ADVANTAGES_TITLE'}
        />
        <div>
          <InfoBlock 
            title={'BROKERAGE_SERVICES_NEW_INFO_TITLE_01'}
            text={'BROKERAGE_SERVICES_NEW_INFO_TEXT_01'}
          />
          <Tariffs
            items={tariffsData}
            alignItems={"start"}
          />
        </div>
        <div>
          <InfoBlock 
            title={'BROKERAGE_SERVICES_NEW_INFO_TITLE_02'}
            text={'BROKERAGE_SERVICES_NEW_INFO_TEXT_02'}
          />
          <div className="contacts">
            <div className="container">
              <h2 className="contacts__title">{this.l10n('BROKERAGE_SERVICES_NEW_CONTACTS_TITLE')}</h2>
              <div className="contacts__text">
                <p>{this.l10n('BROKERAGE_SERVICES_NEW_CONTACTS_TEXT_01')}</p>
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('BROKERAGE_SERVICES_NEW_CONTACTS_TEXT_02'))}}></p>
              </div>
            </div>
          </div>
        </div>
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
        />
      </div>
    </div>
  );
}
